/* eslint-disable prettier/prettier */
/* eslint-disable */

export default {
  defaultProps: {
    color: "transparent",
  },

  styleOverrides: {
    root: {
      boxShadow: "none",
    },
  },
};
